import { css, cx } from '@emotion/css';
import React from 'react';
import { Colors } from '../styles/colors';
import { labelStyle, tabularNumbersStyle, valueStyle } from '../styles/text';

interface iconAtributes {
  className?: string;
}
export interface IInfoProps {
  label: string;
  value: string;
  className?: string;
  iconClassName?: string;
  Icon?: React.FC<iconAtributes>;
}

export const Info = (props: IInfoProps): JSX.Element => {
  const { label, value, className, Icon, iconClassName } = props;
  return (
    <div className={cx(infoStyle, className)}>
      <div className={infoContainerStyle}>
        <span className={infoLabelStyle}>{label}</span>
        <p className={infoValueStyle}>{value}</p>
      </div>
      {Icon && <Icon className={cx(iconStyle, iconClassName)} />}
    </div>
  );
};

const infoStyle = css`
  display: flex;
  width: calc((100% - 0.25rem) / 2);
  margin: 0.5rem 0px;
  min-width: 0;
`;

const iconStyle = css`
  margin-left: 0.875rem;
  flex: 0 0 auto;
`;

const infoContainerStyle = css`
  min-width: 0;
`;

const infoLabelStyle = css`
  ${labelStyle}
  display: block;
  text-transform: capitalize;
  color: ${Colors.TEXT_SECONDARY};
  margin-bottom: 0.25rem;
`;
const infoValueStyle = css`
  ${valueStyle}
  ${tabularNumbersStyle}
  overflow-wrap: anywhere;
`;
